export default __webpack_public_path__ + "static/media/hobbies.35a45751.png";